export const provinces =[
    {
        country:"United States",
        states:[
            {},
            {value:"AL", label:"Alabama"},
            {value:"AK",label:"Alaska"},
            {value:"AS",label:"American Samoa"},
            {value:"AZ",label:"Arizona"},
            {value:"AR",label:"Arkansas"},
            {value:"CA",label:"California"},
            {value:"CO",label:"Colorado"},
            {value:"CT",label:"Connecticut"},
            {value:"DC",label:"District of Columbia (DC)"},
            {value:"DE",label:"Delaware"},
            {value:"FL",label:"Florida"},
            {value:"GA",label:"Georgia"},
            {value:"HI",label:"Hawaii"},
            {value:"ID",label:"Idaho"},
            {value:"IL",label:"Illinois"},
            {value:"IN",label:"Indiana"},
            {value:"IA",label:"Iowa"},
            {value:"KS",label:"Kansas"},
            {value:"KY",label:"Kentucky"},
            {value:"LA",label:"Louisiana"},
            {value:"ME",label:"Maine"},
            {value:"MD",label:"Maryland"},
            {value:"MA",label:"Massachusetts"},
            {value:"MI",label:"Michigan"},
            {value:"MN",label:"Minnesota"},
            {value:"MS",label:"Mississippi"},
            {value:"MO",label:"Missouri"},
            {value:"MT",label:"Montana"},
            {value:"NE",label:"Nebraska"},
            {value:"NV",label:"Nevada"},
            {value:"NH",label:"New Hampshire"},
            {value:"NJ",label:"New Jersey"},
            {value:"NM",label:"New Mexico"},
            {value:"NY",label:"New York"},
            {value:"NC",label:"North Carolina"},
            {value:"ND",label:"North Dakota"},
            {value:"OH",label:"Ohio"},
            {value:"OK",label:"Oklahoma"},
            {value:"OR",label:"Oregon"},
            {value:"PA",label:"Pennsylvania"},
            {value:"RI",label:"Rhode Island"},
            {value:"SC",label:"South Carolina"},
            {value:"SD",label:"South Dakota"},
            {value:"TN",label:"Tennessee"},
            {value:"TX",label:"Texas"},
            {value:"UT",label:"Utah"},
            {value:"VT",label:"Vermont"},
            {value:"VA",label:"Virginia"},
            {value:"WA",label:"Washington"},
            {value:"WV",label:"West Virginia"},
            {value:"WI",label:"Wisconsin"},
            {value:"WY",label:"Wyoming"},
        ]
    },
    {
        country:"Canada",
        states: [
            {},
            {value:"AB",label:"Alberta"},
            {value:"BC",label:"British Columbia"},
            {value:"MB",label:"Manitoba"},
            {value:"NB",label:"New Brunswick"},
            {value:"NL",label:"Newfoundland and Labrador"},
            {value:"NS",label:"Nova Scotia"},
            {value:"NU",label:"Nunavut"},
            {value:"NT",label:"Northwest Territories"},
            {value:"ON",label:"Ontario"},
            {value:"PE",label:"Prince Edward Island"},
            {value:"QC",label:"Quebec"},
            {value:"SK",label:"Saskatchewan"},
            {value:"YT",label:"Yukon"},
        ]
    },
    {
        country:"AU",
        states:[
            {},
            {value:"AC", label:"Ashmore and Cartier Islands"},
            {value:"AA", label:"Australian Antarctic Territory"},
            {value:"ACT",label:"Australian Capital Territory"},
            {value:"CX",label:"Christmas Island"},
            {value:"CC",label:"Cocos Islands"},
            {value:"CS", label:"Coral Sea Islands"},
            {value:"HM",label:"Heard Island and McDonald Islands"},
            {value:"JBT",label:"Jervis Bay Territory"},
            {value:"NSW",label:"New South Wales"},
            {value:"NF",label:"Norfolk Island"},
            {value:"NT",label:"Northern Territory"},
            {value:"QLD",label:"Queensland"},
            {value:"SA",label:"South Australia"},
            {value:"TAS",label:"Tasmania"},
            {value:"VIC",label:"Victoria"},
            {value:"WA",label:"Western Australia"},
        ]
    },
    {
        country:"MX",
        states:[
            {},
            {label:"Aguascalientes",value:"AG"},
            {label:"Baja California",value:"BC"},
            {label:"Baja California Sur",value:"BS"},
            {label:"Campeche",value:"CM"},
            {label:"Chiapas",value:"CS"},
            {label:"Chihuahua",value:"CH"},
            {label:"Coahuila",value:"MX"},
            {label:"Colima",value:"CL"},
            {label:"Federal District",value:"DF"},
            {label:"Durango",value:"DG"},
            {label:"Guanajuato",value:"GT"},
            {label:"Guerrero",value:"GR"},
            {label:"Hidalgo",value:"HG"},
            {label:"Jalisco",value:"JA"},
            {label:"Mexico",value:"ME"},
            {label:"Michoacán",value:"MI"},
            {label:"Morelos",value:"MO"},
            {label:"Nayarit",value:"NA"},
            {label:"Nuevo León",value:"NL"},
            {label:"Oaxaca",value:"OA"},
            {label:"Puebla",value:"PU"},
            {label:"Querétaro",value:"QE"},
            {label:"Quintana Roo",value:"QR"},
            {label:"San Luis Potosí",value:"SL"},
            {label:"Sinaloa",value:"SI"},
            {label:"Sonora",value:"SO"},
            {label:"Tabasco",value:"TB"},
            {label:"Tamaulipas",value:"TM"},
            {label:"Tlaxcala",value:"TL"},
            {label:"Veracruz",value:"VE"},
            {label:"Yucatán",value:"YU"},
            {label:"Zacatecas",value:"ZA"},
        ]
    },
    {
        country:"CN",
        states:[
            {},
            { label: "Chongqing", value: "渝"},
            { label: "Heilongjiang" , value: "黑"},
            { label: "Jilin" , value: "吉"},
            { label: "Hainan", value: "琼"},
            { label: "Beijing" , value: "京"},
            { label: "Liaoning", value: "辽"},
            { label: "Inner Mongolia", value: "蒙"},
            { label: "Tibet", value: "藏"},
            { label: "Qinghai", value: "青"},
            { label: "Ningxia", value: "宁"},
            { label: "Uygur", value: "新"},
            { label: "Gansu", value: "甘"},
            { label: "Hebei", value: "冀"},
            { label: "Henan", value: "豫"},
            { label: "Hubei", value: "鄂"},
            { label: "Hunan", value: "湘"},
            { label: "Shandong", value: "鲁"},
            { label: "Jiangsu", value: "苏"},
            { label: "Anhui", value: "皖"},
            { label: "Shanxi", value: "晋"},
            { label: "Shaanxi", value: "陕"},
            { label: "sichuan", value: "川"},
            { label: "Yunnan", value: "滇"},
            { label: "Guizhou", value: "黔"},
            { label: "Zhejiang", value: "浙"},
            { label: "Fujian", value: "闽"},
            { label: "Guangxi", value: "桂"},
            { label: "Shanghai", value: "沪"},
            { label: "Tianjin", value: "津"},
            { label: "Hongkong", value: "港"},
            { label: "Macao", value: "澳"},
            { label: "Taiwan", value: "台"},
            { label: "Jiangxi", value: "赣"},
            { label: "Guangdong", value: "粤"},
        ]
    },
    {
        country:"GB",
        states:[
            {},
            {value:'I0', label:'Aberconwy and Colwyn'},
            {value:'I1', label:'Aberdeen City'},
            {value:'I2', label:'Aberdeenshire'},
            {value:'I3', label:'Anglesey'},
            {value:'I4', label:'Angus'},
            {value:'I5', label:'Antrim'},
            {value:'I6', label:'Argyll and Bute'},
            {value:'I7', label:'Armagh'},
            {value:'I8', label:'Avon'},
            {value:'I9', label:'Ayrshire'},
            {value:'IB', label:'Bath and NE Somerset'},
            {value:'IC', label:'Bedfordshire'},
            {value:'IE', label:'Belfast'},
            {value:'IF', label:'Berkshire'},
            {value:'IG', label:'Berwickshire'},
            {value:'IH', label:'BFPO'},
            {value:'II', label:'Blaenau Gwent'},
            {value:'IJ', label:'Buckinghamshire'},
            {value:'IK', label:'Caernarfonshire'},
            {value:'IM', label:'Caerphilly'},
            {value:'IO', label:'Caithness'},
            {value:'IP', label:'Cambridgeshire'},
            {value:'IQ', label:'Cardiff'},
            {value:'IR', label:'Cardiganshire'},
            {value:'IS', label:'Carmarthenshire'},
            {value:'IT', label:'Ceredigion'},
            {value:'IU', label:'Channel Islands'},
            {value:'IV', label:'Cheshire'},
            {value:'IW', label:'City of Bristol'},
            {value:'IX', label:'Clackmannanshire'},
            {value:'IY', label:'Clwyd'},
            {value:'IZ', label:'Conwy'},
            {value:'J0', label:'Cornwall/Scilly'},
            {value:'J1', label:'Cumbria'},
            {value:'J2', label:'Denbighshire'},
            {value:'J3', label:'Derbyshire'},
            {value:'J4', label:'Derry/Londonderry'},
            {value:'J5', label:'Devon'},
            {value:'J6', label:'Dorset'},
            {value:'J7', label:'Down'},
            {value:'J8', label:'Dumfries and Galloway'},
            {value:'J9', label:'Dunbartonshire'},
            {value:'JA', label:'Dundee'},
            {value:'JB', label:'Durham'},
            {value:'JC', label:'Dyfed'},
            {value:'JD', label:'East Ayrshire'},
            {value:'JE', label:'East Dunbartonshire'},
            {value:'JF', label:'East Lothian'},
            {value:'JG', label:'East Renfrewshire'},
            {value:'JH', label:'East Riding Yorkshire'},
            {value:'JI', label:'East Sussex'},
            {value:'JJ', label:'Edinburgh'},
            {value:'JK', label:'England'},
            {value:'JL', label:'Essex'},
            {value:'JM', label:'Falkirk'},
            {value:'JN', label:'Fermanagh'},
            {value:'JO', label:'Fife'},
            {value:'JP', label:'Flintshire'},
            {value:'JQ', label:'Glasgow'},
            {value:'JR', label:'Gloucestershire'},
            {value:'JS', label:'Greater London'},
            {value:'JT', label:'Greater Manchester'},
            {value:'JU', label:'Gwent'},
            {value:'JV', label:'Gwynedd'},
            {value:'JW', label:'Hampshire'},
            {value:'JX', label:'Hartlepool'},
            {value:'HAW', label:'Hereford and Worcester'},
            {value:'JY', label:'Hertfordshire'},
            {value:'JZ', label:'Highlands'},
            {value:'K0', label:'Inverclyde'},
            {value:'K1', label:'Inverness-Shire'},
            {value:'K2', label:'Isle of Man'},
            {value:'K3', label:'Isle of Wight'},
            {value:'K4', label:'Kent'},
            {value:'K5', label:'Kincardinshire'},
            {value:'K6', label:'Kingston Upon Hull'},
            {value:'K7', label:'Kinross-Shire'},
            {value:'K8', label:'Kirklees'},
            {value:'K9', label:'Lanarkshire'},
            {value:'KA', label:'Lancashire'},
            {value:'KB', label:'Leicestershire'},
            {value:'KC', label:'Lincolnshire'},
            {value:'KD', label:'Londonderry'},
            {value:'KE', label:'Merseyside'},
            {value:'KF', label:'Merthyr Tydfil'},
            {value:'KG', label:'Mid Glamorgan'},
            {value:'KI', label:'Mid Lothian'},
            {value:'KH', label:'Middlesex'},
            {value:'KJ', label:'Monmouthshire'},
            {value:'KK', label:'Moray'},
            {value:'KL', label:'Neath & Port Talbot'},
            {value:'KM', label:'Newport'},
            {value:'KN', label:'Norfolk'},
            {value:'KP', label:'North Ayrshire'},
            {value:'KQ', label:'North East Lincolnshire'},
            {value:'KR', label:'North Lanarkshire'},
            {value:'KT', label:'North Lincolnshire'},
            {value:'KU', label:'North Somerset'},
            {value:'KV', label:'North Yorkshire'},
            {value:'KO', label:'Northamptonshire'},
            {value:'KW', label:'Northern Ireland'},
            {value:'KX', label:'Northumberland'},
            {value:'KZ', label:'Nottinghamshire'},
            {value:'L0', label:'Orkney and Shetland Isles'},
            {value:'L1', label:'Oxfordshire'},
            {value:'L2', label:'Pembrokeshire'},
            {value:'L3', label:'Perth and Kinross'},
            {value:'L4', label:'Powys'},
            {value:'L5', label:'Redcar and Cleveland'},
            {value:'L6', label:'Renfrewshire'},
            {value:'L7', label:'Rhonda Cynon Taff'},
            {value:'L8', label:'Rutland'},
            {value:'L9', label:'Scottish Borders'},
            {value:'LB', label:'Shetland'},
            {value:'LC', label:'Shropshire'},
            {value:'LD', label:'Somerset'},
            {value:'LE', label:'South Ayrshire'},
            {value:'LF', label:'South Glamorgan'},
            {value:'LG', label:'South Gloucesteshire'},
            {value:'LH', label:'South Lanarkshire'},
            {value:'LI', label:'South Yorkshire'},
            {value:'LJ', label:'Staffordshire'},
            {value:'LK', label:'Stirling'},
            {value:'LL', label:'Stockton On Tees'},
            {value:'LM', label:'Suffolk'},
            {value:'LN', label:'Surrey'},
            {value:'LO', label:'Swansea'},
            {value:'LP', label:'Torfaen'},
            {value:'LQ', label:'Tyne and Wear'},
            {value:'LR', label:'Tyrone'},
            {value:'LS', label:'Vale Of Glamorgan'},
            {value:'LT', label:'Wales'},
            {value:'LU', label:'Warwickshire'},
            {value:'LV', label:'West Berkshire'},
            {value:'LW', label:'West Dunbartonshire'},
            {value:'LX', label:'West Glamorgan'},
            {value:'LY', label:'West Lothian'},
            {value:'LZ', label:'West Midlands'},
            {value:'M0', label:'West Sussex'},
            {value:'M1', label:'West Yorkshire'},
            {value:'M2', label:'Western Isles'},
            {value:'M3', label:'Wiltshire'},
            {value:'M4', label:'Wirral'},
            {value:'M5', label:'Worcestershire'},
            {value:'M6', label:'Wrexham'},
            {value:'M7', label:'York'},
        ]
    },
    {
        country:"DE",
        states:[
            {},
            {value:"BW",label:"Baden-Württemberg"},
            {value:"BY",label:"Bayern"},
            {value:"BE",label:"Berlin"},
            {value:"BB",label:"Brandenburg"},
            {value:"HB",label:"Bremen"},
            {value:"HH",label:"Hamburg"},
            {value:"HE",label:"Hessen"},
            {value:"MV",label:"Mecklenburg-Vorpommern"},
            {value:"NI",label:"Niedersachsen"},
            {value:"NW",label:"Nordrhein-Westfalen"},
            {value:"RP",label:"Rheinland-Pfalz"},
            {value:"SL",label:"Saarland"},
            {value:"SN",label:"Sachsen"},
            {value:"ST",label:"Sachsen-Anhalt"},
            {value:"SH",label:"Schleswig-Holstein"},
            {value:"TH",label:"Thüringen"},    
        ]
    },
    {
        country:"NL",
        states:[
            {},
            {value:"DR",label:"Drenthe"},
            {value:"FL",label:"Flevoland"},
            {value:"FR",label:"Friesland"},
            {value:"GD",label:"Gelderland"},
            {value:"GR",label:"Groningen"},
            {value:"LB",label:"Limburg"},
            {value:"NB",label:"Noord-Brabant"},
            {value:"NH",label:"Noord-Holland"},
            {value:"OV",label:"Overijssel"},
            {value:"UT",label:"Utrecht"},
            {value:"ZH",label:"Zuid-Holland"},
            {value:"ZL",label:"Zeeland"},
        ]
    },
    {
        country:"BE",
        states:[
            {},
            {value:"ANT",label:"Antwerpen"},
            {value:"HAI",label:"Henegouwen"},
            {value:"LIE",label:"Luik"},
            {value:"LIM",label:"Limburg"},
            {value:"LUX",label:"Luxemburg"},
            {value:"NAM",label:"Namen"},
            {value:"OVL",label:"Oost-Vlaanderen"},
            {value:"VBR",label:"Vlaams-Brabant"},
            {value:"WBR",label:"Waals-Brabant"},
            {value:"WVL",label:"West-Vlaanderen"},
        ]
    },
    {
        country:"DK",
        states:[
            {},
            {label:"Hovedstaden"},
            {label:"Midtjylland"},
            {label:"Nordjylland"},
            {label:"Sjælland"},
            {label:"Syddanmark"},
        ]
    },
    {
        country:"TR",
        states:[
            {},
            {value:'01', label:'Adana'},
            {value:'02', label:'Adıyaman'},
            {value:'03', label:'Afyonkarahisar'},
            {value:'04', label:'Ağrı'},
            {value:'05', label:'Aksaray'},
            {value:'06', label:'Amasya'},
            {value:'07', label:'Ankara'},
            {value:'08', label:'Antalya'},
            {value:'09', label:'Ardahan'},
            {value:'10', label:'Artvin'},
            {value:'11', label:'Aydın'},
            {value:'12', label:'Balıkesir'},
            {value:'13', label:'Bartın'},
            {value:'14', label:'Batman'},
            {value:'15', label:'Bayburt'},
            {value:'16', label:'Bilecik'},
            {value:'17', label:'Bingöl'},
            {value:'18', label:'Bitlis'},
            {value:'19', label:'Bolu'},
            {value:'20', label:'Burdur'},
            {value:'21', label:'Bursa'},
            {value:'22', label:'Çanakkale'},
            {value:'23', label:'Çankırı'},
            {value:'24', label:'Çorum'},
            {value:'25', label:'Denizli'},
            {value:'26', label:'Diyarbakır'},
            {value:'27', label:'Düzce'},
            {value:'28', label:'Edirne'},
            {value:'29', label:'Elazığ'},
            {value:'30', label:'Erzincan'},
            {value:'31', label:'Erzurum'},
            {value:'32', label:'Eskişehir'},
            {value:'33', label:'Gaziantep'},
            {value:'34', label:'Giresun'},
            {value:'35', label:'Gümüşhane'},
            {value:'36', label:'Hakkâri'},
            {value:'37', label:'Hatay'},
            {value:'38', label:'Iğdır'},
            {value:'39', label:'Isparta'},
            {value:'40', label:'İstanbul'},
            {value:'41', label:'İzmir'},
            {value:'42', label:'Kahramanmaraş'},
            {value:'43', label:'Karabük'},
            {value:'44', label:'Karaman'},
            {value:'45', label:'Kars'},
            {value:'46', label:'Kastamonu'},
            {value:'47', label:'Kayseri'},
            {value:'48', label:'Kırıkkale'},
            {value:'49', label:'Kırklareli'},
            {value:'50', label:'Kırşehir'},
            {value:'51', label:'Kilis'},
            {value:'52', label:'Kocaeli'},
            {value:'53', label:'Konya'},
            {value:'54', label:'Kütahya'},
            {value:'55', label:'Malatya'},
            {value:'56', label:'Manisa'},
            {value:'57', label:'Mardin'},
            {value:'58', label:'Mersin'},
            {value:'59', label:'Muğla'},
            {value:'60', label:'Muş'},
            {value:'61', label:'Nevşehir'},
            {value:'62', label:'Niğde'},
            {value:'63', label:'Ordu'},
            {value:'64', label:'Osmaniye'},
            {value:'65', label:'Rize'},
            {value:'66', label:'Sakarya'},
            {value:'67', label:'Samsun'},
            {value:'68', label:'Siirt'},
            {value:'69', label:'Sinop'},
            {value:'70', label:'Sivas'},
            {value:'71', label:'Şanlıurfa'},
            {value:'72', label:'Şırnak'},
            {value:'73', label:'Tekirdağ'},
            {value:'74', label:'Tokat'},
            {value:'75', label:'Trabzon'},
            {value:'76', label:'Tunceli'},
            {value:'77', label:'Uşak'},
            {value:'78', label:'Van'},
            {value:'79', label:'Yalova'},
            {value:'80', label:'Yozgat'},
            {value:'81', label:'Zonguldak'},
        ]
    },
    {
        country:"ID",
            states:[
                {},    
            { value: "AC", label: "Special Region of Aceh"},
            { value: "BA", label: "Bali"},
            { value: "BB", label: "Bangka–Belitung Islands"},
            { value: "BT", label: "Banten"},
            { value: "BE", label: "Bengkulu"},
            { value: "JT", label: "Central Java"},
            { value: "KT", label: "Central Kalimantan"},
            { value: "ST", label: "Central Sulawesi"},
            { value: "JI", label: "East Java"},
            { value: "KI", label: "East Kalimantan"},
            { value: "NT", label: "East Nusa Tenggara"},
            { value: "GO", label: "Gorontalo"},
            { value: "JK", label: "Jakarta Special Capital Region"},
            { value: "JA", label: "Jambi"},
            { value: "LA", label: "Lampung"},
            { value: "MA", label: "Maluku"},
            { value: "KU", label: "North Kalimantan"},
            { value: "MU", label: "North Maluku"},
            { value: "SA", label: "North Sulawesi"},
            { value: "SU", label: "North Sumatra"},
            { value: "PA", label: "Special Region of Papua"},
            { value: "RI", label: "Riau"},
            { value: "KR", label: "Riau Islands"},
            { value: "SG", label: "Southeast Sulawesi"},
            { value: "KS", label: "South Kalimantan"},
            { value: "SN", label: "South Sulawesi"},
            { value: "SS", label: "South Sumatra"},
            { value: "JB", label: "West Java"},
            { value: "KB", label: "West Kalimantan"},
            { value: "NB", label: "West Nusa Tenggara"},
            { value: "PB", label: "Special Region of West Papua"},
            { value: "SR", label: "West Sulawesi"},
            { value: "SB", label: "West Sumatra"},
            { value: "YO", label: "Special Region of Yogyakarta"},

        ]
    },
    {
        country:"JO",
        states:[
            {},  
            { value:"IR", label: "Irbid"},
            { value:"AJ", label: "Ajloun"},
            { value:"JA", label: "Jerash"},
            { value:"MA", label: "Mafraq"},
            { value:"BA", label: "Balqa"},
            { value:"MN", label: "Amman"},
            { value:"AZ", label: "Zarqa"},
            { value:"MD", label: "Madaba"},
            { value:"KA", label: "Karak"},
            { value:"AT", label: "Tafilah"},
            { value:"MN", label: "Ma'an"},
            { value:"AQ", label: "Aqaba"},
        ]
    },
    {
        country:"IN",
        states:[
            {},
            { value: "AP", label: "Andhra Pradesh"},
            { value: "AR", label: "Arunachal Pradesh"},
            { value: "AS", label: "Assam"},
            { value: "BR", label: "Bihar"},
            { value: "CT", label: "Chhattisgarh"},
            { value: "GA", label: "Goa"},
            { value: "GJ", label: "Gujarat"},
            { value: "HR", label: "Haryana"},
            { value: "HP", label: "Himachal Pradesh"},
            { value: "JK", label: "Jammu and Kashmir"},
            { value: "JH", label: "Jharkhand"},
            { value: "KA", label: "Karnataka"},
            { value: "KL", label: "Kerala"},
            { value: "MP", label: "Madhya Pradesh"},
            { value: "MH", label: "Maharashtra"},
            { value: "MN", label: "Manipur"},
            { value: "ML", label: "Meghalaya"},
            { value: "MZ", label: "Mizoram"},
            { value: "NL", label: "Nagaland"},
            { value: "OR", label: "Odisha"},
            { value: "PB", label: "Punjab"},
            { value: "RJ", label: "Rajasthan"},
            { value: "SK", label: "Sikkim"},
            { value: "TN", label: "Tamil Nadu"},
            { value: "TG", label: "Telangana"},
            { value: "TR", label: "Tripura"},
            { value: "UP", label: "Uttar Pradesh"},
            { value: "UT", label: "Uttarakhand"},
            { value: "WB", label: "West Bengal"},
            { value: "AN", label: "Andaman and Nicobar Islands"},
            { value: "CH", label: "Chandigarh"},
            { value: "DN", label: "Dadra and Nagar Haveli"},
            { value: "DD", label: "Daman and Diu"},
            { value: "LD", label: "Lakshadweep"},
            { value: "DL", label: "National Capital Territory of Delhi"},
            { value: "PY", label: "Puducherry"},

        ]
    },
    {
        country:"KH",
        states:[
            {},
            {value:'12', label:'Phnom Penh'},
            {value:'2', label:'Baat Dambang'},
            {value:'1', label:'Banteay Mean Choăy'},
            {value:'3', label:'Kampong Chaam'},
            {value:'4', label:'Kampong Chhnang'},
            {value:'5', label:'Kampong Spueu'},
            {value:'6', label:'Kampong Thum'},
            {value:'7', label:'Kampot'},
            {value:'8', label:'Kandaal'},
            {value:'9', label:'Kaoh Kong'},
            {value:'10', label:'Kracheh'},
            {value:'23', label:'Kaeb'},
            {value:'24', label:'Pailin'},
            {value:'18', label:'Preah Sihanouk'},
            {value:'11', label:'Mondol Kiri'},
            {value:'22', label:'Otdar Mean Chey'},
            {value:'15', label:'Pousaat'},
            {value:'13', label:'Preah Vihear'},
            {value:'14', label:'Prey Veaeng'},
            {value:'16', label:'Rotanak Kiri'},
            {value:'17', label:'Siem Reab'},
            {value:'19', label:'Stueng Traeng'},
            {value:'20', label:'Svaay Rieng'},
            {value:'21', label:'Taakaev'},
            {value:'25', label:'Tbong Khmum'},
        ]
    },
    {
        country:"ET",
        states:[
            {},
            {value:'AA', label:'Addis Ababa'},
            {value:'DD', label:'Dire Dawa'},
            {value:'AF', label:'Afar'},
            {value:'AM', label:'Amara'},
            {value:'BE', label:'Benshangul-Gumaz'},
            {value:'GA', label:'Gambela Peoples'},
            {value:'HA', label:'Harari People'},
            {value:'OR', label:'Oromia'},
            {value:'SO', label:'Somali'},
            {value:'TI', label:'Tigrai'},
            {value:'SN', label:'Southern Nations'},

        ]
    },
    {
        country: 'PE',
        states: [
            {},
            {value:"LMA", label: "Municipalidad Metropolitana de Lima"},
            {value:"AMA", label: "Amazonas"},
            {value:"ANC", label: "Ancash"},
            {value:"APU", label: "Apurímac"},
            {value:"ARE", label: "Arequipa"},
            {value:"AYA", label: "Ayacucho"},
            {value:"CAJ", label: "Cajamarca"},
            {value:"CUS", label: "Cusco"},
            {value:"CAL", label: "El Callao"},
            {value:"HUV", label: "Huancavelica"},
            {value:"HUC", label: "Huánuco"},
            {value:"ICA", label: "Ica"},
            {value:"JUN", label: "Junín"},
            {value:"LAL", label: "La Libertad"},
            {value:"LAM", label: "Lambayeque"},
            {value:"LIM", label: "Lima"},
            {value:"LOR", label: "Loreto"},
            {value:"MDD", label: "Madre de Dios"},
            {value:"MOQ", label: "Moquegua"},
            {value:"PAS", label: "Pasco"},
            {value:"PIU", label: "Piura"},
            {value:"PUN", label: "Puno"},
            {value:"SAM", label: "San Martín"},
            {value:"TAC", label: "Tacna"},
            {value:"TUM", label: "Tumbes"},
            {value:"UCA", label: "Ucayali"},
            ]
        },
        {
            country: 'CU',
            states: [
                {},
                {value:"09", label: "Camagüey"},
                {value:"08", label: "Ciego de Ávila"},
                {value:"06", label: "Cienfuegos"},
                {value:"12", label: "Granma"},
                {value:"14", label: "Guantánamo"},
                {value:"11", label: "Holguín"},
                {value:"03", label: "La Habana"},
                {value:"15", label: "Artemisa"},
                {value:"10", label: "Las Tunas"},
                {value:"04", label: "Matanzas"},
                {value:"16", label: "Mayabeque"},
                {value:"01", label: "Pinar del Río"},
                {value:"07", label: "Sancti Spíritus"},
                {value:"13", label: "Santiago de Cuba"},
                {value:"05", label: "Villa Clara"},
                {value:"99", label: "Isla de la Juventud"},
            ]
        },
        {
            country: 'AR',
            states: 
            [
                {},
                {value:"C", label: "Ciudad Autónoma de Buenos Aires"},
                {value:"B", label: "Buenos Aires"},
                {value:"K", label: "Catamarca"},
                {value:"H", label: "Chaco"},
                {value:"U", label: "Chubut"},
                {value:"X", label: "Córdoba"},
                {value:"W", label: "Corrientes"},
                {value:"E", label: "Entre Ríos"},
                {value:"P", label: "Formosa"},
                {value:"Y", label: "Jujuy"},
                {value:"L", label: "La Pampa"},
                {value:"F", label: "La Rioja"},
                {value:"M", label: "Mendoza"},
                {value:"N", label: "Misiones"},
                {value:"Q", label: "Neuquén"},
                {value:"R", label: "Río Negro"},
                {value:"A", label: "Salta"},
                {value:"J", label: "San Juan"},
                {value:"D", label: "San Luis"},
                {value:"Z", label: "Santa Cruz"},
                {value:"S", label: "Santa Fe"},
                {value:"G", label: "Santiago del Estero"},
                {value:"V", label: "Tierra del Fuego, Antártida e Islas del Atlántico Sur"},
                {value:"T", label: "Tucumán"},
            ]
        },
        {
            country: 'SO',
            states: 
            [
                {},
                {value:"AW", label: "Awdal"},
                {value:"BK", label: "Bakool"},
                {value:"BN", label: "Banaadir"},
                {value:"BE", label: "Bari"},
                {value:"BY", label: "Bay"},
                {value:"GA", label: "Galguduud"},
                {value:"GE", label: "Gedo"},
                {value:"HI", label: "Hiiraan"},
                {value:"JD", label: "Jubbada Dhexe"},
                {value:"JH", label: "Jubbada Hoose"},
                {value:"MU", label: "Mudug"},
                {value:"NU", label: "Nugaal"},
                {value:"SA", label: "Sanaag"},
                {value:"SD", label: "Shabeellaha Dhexe"},
                {value:"SH", label: "Shabeellaha Hoose"},
                {value:"SO", label: "Sool"},
                {value:"TO", label: "Togdheer"},
                {value:"WO", label: "Woqooyi Galbeed"},
            ]
        },
        {
            country: 'CL',
            states: 
            [
                {},
                {value:"AI", label: "Aisén del General Carlos Ibañez del Campo" },
                {value:"AN", label: "Antofagasta"},
                {value:"AP", label: "Arica y Parinacota" },
                {value:"AR", label: "La Araucanía" },
                {value:"AT", label: "Atacama" },
                {value:"BI", label: "Biobío" },
                {value:"CO", label: "Coquimbo" },
                {value:"LI", label: "Libertador General Bernardo O'Higgins" },
                {value:"LL", label: "Los Lagos" },
                {value:"LR", label: "Los Ríos" },
                {value:"MA", label: "Magallanes" },
                {value:"ML", label: "Maule" },
                {value:"NB", label: "Ñuble" },
                {value:"RM", label: "Región Metropolitana de Santiago" },
                {value:"TA", label: "Tarapacá" },
                {value:"VS", label: "Valparaíso" },
            ]
        },
        {
            country: 'BO',
            states: 
            [
                {},
                {value:"B", label:"Beni"},
                {value:"H", label:"Chuquisaca"},
                {value:"C", label:"Cochabamba"},
                {value:"L", label: "La Paz"},
                {value:"O", label: "Oruro"},
                {value:"N", label: "Pando"},
                {value:"P", label:"Potosí"},
                {value:"S", label:"Santa Cruz"},
                {value:"T", label: "Tarija"},
            ]
        },
        {
            country: 'ES',
            states: 
            [
                {},
                {value: "C", label: "La Coruña"},
                {value: "LU", label: "Lugo"},
                {value: "BI", label: "Vizcaya"},
                {value: "SS", label: "Guipúzcoa"},
                {value: "HU", label: "Huesca"},
                {value: "L", label: "Lérida"},
                {value: "GI", label: "Gerona"},
                {value: "B", label: "Barcelona"},
                {value: "T", label: "Tarragona"},
                {value:"CS", label: "Castellón"},
                {value: "V", label: "Valencia"},
                {value: "A", label: "Alicante"},
                {value: "MU", label: "Murcia"},
                {value: "Z", label: "Zaragoza"},
                {value: "TE", label: "Teruel",},
                {value: "CU", label: "Cuenca",},
                {value: "AB", label: "Albacete",},
                {value: "AL", label: "Almeria",},
                {value: "GR", label: "Granada",},
                {value: "MA", label: "Málaga",},
                {value: "TF", label: "Tenerife",},
                {value: "CA", label: "Cádiz",},
                {value: "SE", label: "Sevilla",},
                {value: "H", label: "Huelva"},
                {value: "GC", label: "Las Palmas"},
                {value: "M", label: "Madrid"},
                {value: "BA", label: "Badajoz"},
                {value: "CC", label: "Cáceres"},
                {value: "TO", label: "Toledo"},
                {value: "CR", label: "Ciudad Real"},
                {value: "SA", label: "Salamanca"},
                {value: "CO", label: "Córdoba"},
                {value:"J", label: "Jaén"},
                {value: "AV", label: "Ávila"},
                {value: "VA", label: "Valladolid"},
                {value: "ZA", label: "Zamora"},
                {value: "VI", label: "Álava"},
                {value: "SG", label: "Segovia"},
                {value: "BU", label: "Burgos"},
                {value: "PO", label: "Pontevedra"},
                {value: "LE", label: "León"},
                {value: "OU", label: "Orense"},
                {value: "P", label: "Palencia"},
                {value: "LO", label: "La Rioja"},
                {value: "SO", label: "Soria"},
                {value: "GU", label: "Guadalajara"},
            ]
        },
        {
            country: 'BD',
            states: 
            [
                {},
                { value: "A", label:"Barisal"},
                { value: "B", label:"Chattogram"},
                { value: "C", label:"Dhaka"},
                { value: "D", label:"Khulna"},
                { value: "E", label:"Rajshahi"},
                { value: "F", label:"Rangpur"},
                { value: "G", label:"Sylhet"},
                { value: "H", label:"Mymensingh"},
            ]
        },
        {
            country: 'PK',
            states: 
            [
                {},
                {value:"AJK", label: "Azad Azad Jammu and Kashmir"},
                {value:"BL", label: "Balochistan"},
                {value:"GB", label: "Gilgit−Baltistan"},
                {value:"ICT", label: "Islamabad Capital Territory"},
                {value:"KP", label: "Khyber Pakhtunkhwa"},
                {value:"PJ", label: "Punjab"},
                {value:"SN", label: "Sindh"},
        ]
        },
        {
            country: 'NG',
            states: 
            [
                {},
                { value: "AB", label: "Abia"},
                { value: "FC", label: "Abuja"},
                { value: "AD", label: "Adamawa"},
                { value: "AK", label: "Akwa Ibom"},
                { value: "AN", label: "Anambra"},
                { value: "BA", label: "Bauchi"},
                { value: "BY", label: "Bayelsa"},
                { value: "BE", label: "Benue"},
                { value: "BO", label: "Borno"},
                { value: "CR", label: "Cross River"},
                { value: "DE", label: "Delta"},
                { value: "EB", label: "Ebonyi"},
                { value: "ED", label: "Edo"},
                { value: "EK", label: "Ekiti"},
                { value: "EN", label: "Enugu"},
                { value: "GO", label: "Gombe"},
                { value: "IM", label: "Imo"},
                { value: "JI", label: "Jigawa"},
                { value: "KD", label: "Kaduna"},
                { value: "KN", label: "Kano"},
                { value: "KT", label: "Katsina"},
                { value: "KE", label: "Kebbi"},
                { value: "KO", label: "Kogi"},
                { value: "KW", label: "Kwara"},
                { value: "LA", label: "Lagos"},
                { value: "NA", label: "Nasarawa"},
                { value: "NI", label: "Niger"},
                { value: "OG", label: "Ogun"},
                { value: "ON", label: "Ondo"},
                { value: "OS", label: "Osun"},
                { value: "OY", label: "Oyo"},
                { value: "PL", label: "Plateau"},
                { value: "RI", label: "Rivers"},
                { value: "SO", label: "Sokoto"},
                { value: "TA", label: "Taraba"},
                { value: "YO", label: "Yobe"},
                { value: "ZA", label: "Zamfara"},
            ]
        },
        {
            country: 'JP',
            states: 
            [
                {},
                {value:"23", label:"Aichi"},
                {value:"05", label:"Akita"},
                {value:"02", label:"Aomori"},
                {value:"12", label:"Chiba"},
                {value:"38", label:"Ehime"},
                {value:"18", label:"Fukui"},
                {value:"40", label:"Fukuoka"},
                {value:"07", label:"Fukushima"},
                {value:"21", label:"Gifu"},
                {value:"10", label:"Gunma"},
                {value:"34", label:"Hiroshima"},
                {value:"01", label:"Hokkaidō"},
                {value:"28", label:"Hyōgo"},
                {value:"08", label:"Ibaraki"},
                {value:"17", label:"Ishikawa"},
                {value:"03", label:"Iwate"},
                {value:"37", label:"Kagawa"},
                {value:"46", label:"Kagoshima"},
                {value:"14", label:"Kanagawa"},
                {value:"39", label:"Kōchi"},
                {value:"43", label:"Kumamoto"},
                {value:"26", label:"Kyōto"},
                {value:"24", label:"Mie"},
                {value:"04", label:"Miyagi"},
                {value:"45", label:"Miyazaki"},
                {value:"20", label:"Nagano"},
                {value:"42", label:"Nagasaki"},
                {value:"29", label:"Nara"},
                {value:"15", label:"Niigata"},
                {value:"44", label:"Ōita"},
                {value:"33", label:"Okayama"},
                {value:"47", label:"Okinawa"},
                {value:"27", label:"Ōsaka"},
                {value:"41", label:"Saga"},
                {value:"11", label:"Saitama"},
                {value:"25", label:"Shiga"},
                {value:"32", label:"Shimane"},
                {value:"22", label:"Shizuoka"},
                {value:"09", label:"Tochigi"},
                {value:"36", label:"Tokushima"},
                {value:"13", label:"Tōkyō"},
                {value:"31", label:"Tottori"},
                {value:"16", label:"Toyama"},
                {value:"30", label:"Wakayama"},
                {value:"06", label:"Yamagata"},
                {value:"35", label:"Yamaguchi"},
                {value:"19", label:"Yamanashi"},
            ]
        },
        {
            country: 'AT',
            states: 
            [
                {},
                {value:"B", label:"Burgenland"},
                {value:"K", label:"Kärnten"},
                {value:"NÖ", label:"Niederösterreich"},
                {value:"OÖ", label:"Oberösterreich"},
                {value:"S", label:"Salzburg"},
                {value:"ST", label:"Steiermark"},
                {value:"T", label:"Tirol"},
                {value:"V", label:"Vorarlberg"},
                {value:"W", label:"Wien"},
            ]
        },
        {
            country: 'BR',
            states: 
            [
                {},
                {value:"AC", label:"Acre"},
                {value:"AL", label:"Alagoas"},
                {value:"AP", label:"Amapá"},
                {value:"AM", label:"Amazonas"},
                {value:"BA", label:"Bahia"},
                {value:"CE", label:"Ceará"},
                {value:"DF", label:"Distrito Federal"},
                {value:"ES", label:"Espírito Santo"},
                {value:"GO", label:"Goiás"},
                {value:"MA", label:"Maranhão"},
                {value:"MT", label:"Mato Grosso"},
                {value:"MS", label:"Mato Grosso do Sul"},
                {value:"MG", label:"Minas Gerais"},
                {value:"PA", label:"Pará"},
                {value:"PB", label:"Paraíba"},
                {value:"PR", label:"Paraná"},
                {value:"PE", label:"Pernambuco"},
                {value:"PI", label:"Piauí"},
                {value:"RJ", label:"Rio de Janeiro"},
                {value:"RN", label:"Rio Grande do Norte"},
                {value:"RS", label:"Rio Grande do Sul"},
                {value:"RO", label:"Rondônia"},
                {value:"RR", label:"Roraima"},
                {value:"SC", label:"Santa Catarina"},
                {value:"SP", label:"São Paulo"},
                {value:"SE", label:"Sergipe"},
                {value:"TO", label:"Tocantins"},
            ]
        },
        {
            country: 'PH',
            states: 
            [
                {},
                {value:"ABR", label: "Abra"},
                {value:"AGN", label: "Agusan del Norte"},
                {value:"AGS", label: "Agusan del Sur"},
                {value:"AKL", label: "Aklan"},
                {value:"ALB", label: "Albay"},
                {value:"ANT", label: "Antique"},
                {value:"APA", label: "Apayao"},
                {value:"AUR", label: "Aurora"},
                {value:"BAS", label: "Basilan"},
                {value:"BAN", label: "Bataan"},
                {value:"BTN", label: "Batanes"},
                {value:"BTG", label: "Batangas"},
                {value:"BEN", label: "Benguet"},
                {value:"BIL", label: "Biliran"},
                {value:"BOH", label: "Bohol"},
                {value:"BUK", label: "Bukidnon"},
                {value:"BUL", label: "Bulacan"},
                {value:"CAG", label: "Cagayan"},
                {value:"CAN", label: "Camarines Norte"},
                {value:"CAS", label: "Camarines Sur"},
                {value:"CAM", label: "Camiguin"},
                {value:"CAP", label: "Capiz"},
                {value:"CAT", label: "Catanduanes"},
                {value:"CAV", label: "Cavite"},
                {value:"CEB", label: "Cebu"},
                {value:"NCO", label: "Cotabato"},
                {value:"COM", label: "Davao de Oro"},
                {value:"DAV", label: "Davao del Norte"},
                {value:"DAS", label: "Davao del Sur"},
                {value:"DVO", label: "Davao Occidental"},
                {value:"DAO", label: "Davao Oriental"},
                {value:"DIN", label: "Dinagat Islands"},
                {value:"EAS", label: "Eastern Samar"},
                {value:"GUI", label: "Guimaras"},
                {value:"IFU", label: "Ifugao"},
                {value:"ILN", label: "Ilocos Norte"},
                {value:"ILS", label: "Ilocos Sur"},
                {value:"ILI", label: "Iloilo"},
                {value:"ISA", label: "Isabela"},
                {value:"KAL", label: "Kalinga"},
                {value:"LUN", label: "La Union"},
                {value:"LAG", label: "Laguna"},
                {value:"LAN", label: "Lanao del Norte"},
                {value:"LAS", label: "Lanao del Sur"},
                {value:"LEY", label: "Leyte"},
                {value:"MAG", label: "Maguindanao"},
                {value:"MAD", label: "Marinduque"},
                {value:"MAS", label: "Masbate"},
                {value:"MSC", label: "Misamis Occidental"},
                {value:"MSR", label: "Misamis Oriental"},
                {value:"MOU", label: "Mountain Province"},
                {value:"NEC", label: "Negros Occidental"},
                {value:"NER", label: "Negros Oriental"},
                {value:"NSA", label: "Northern Samar"},
                {value:"NUE", label: "Nueva Ecija"},
                {value:"NUV", label: "Nueva Vizcaya"},
                {value:"MDC", label: "Occidental Mindoro"},
                {value:"MDR", label: "Oriental Mindoro"},
                {value:"PLW", label: "Palawan"},
                {value:"PAM", label: "Pampanga"},
                {value:"PAN", label: "Pangasinan"},
                {value:"QUE", label: "Quezon"},
                {value:"QUI", label: "Quirino"},
                {value:"RIZ", label: "Rizal"},
                {value:"ROM", label: "Romblon"},
                {value:"WSA", label: "Samar"},
                {value:"SAR", label: "Sarangani"},
                {value:"SIG", label: "Siquijor"},
                {value:"SOR", label: "Sorsogon"},
                {value:"SCO", label: "South Cotabato"},
                {value:"SLE", label: "Southern Leyte"},
                {value:"SUK", label: "Sultan Kudarat"},
                {value:"SLU", label: "Sulu"},
                {value:"SUN", label: "Surigao del Norte"},
                {value:"SUR", label: "Surigao del Sur"},
                {value:"TAR", label: "Tarlac"},
                {value:"TAW", label: "Tawi-Tawi"},
                {value:"ZMB", label: "Zambales"},
                {value:"ZAN", label: "Zamboanga del Norte"},
                {value:"ZAS", label: "Zamboanga del Sur"},
                {value:"ZSI", label: "Zamboanga Sibugay"},
                {value:"00", label: "Metro Manila"},
            ]
        },
        {
            country: 'VN',
            states: 
            [
                {},
                {value: "HN", label: "Hà Nội"},
                {value: "03", label: "Hà Giang"},
                {value: "04", label: "Cao Bằng"},
                {value: "H", label: "Bắc Kạn"},
                {value: "G", label: "Tuyên Quang"},
                {value: "02", label: "Lào Cai"},
                {value:"71", label: "Điện Biên"},
                {value:"01", label: "Lai Châu"},
                {value:"05", label: "Sơn La"},
                {value:"06", label: "Yên Bái"},
                {value:"14", label: "Hòa Bình"},
                {value:"69", label: "Thái Nguyên"},
                {value:"09", label: "Lạng Sơn"},
                {value:"13", label: "Quảng Ninh"},
                {value:"54", label: "Bắc Giang"},
                {value:"68", label: "Phú Thọ"},
                {value:"70", label: "Vĩnh Phúc"},
                {value:"56", label: "Bắc Ninh"},
                {value:"61", label: "Hải Dương"},
                {value:"HP", label: "Hải Phòng"},
                {value:"66", label: "Hưng Yên"},
                {value:"20", label: "Thái Bình"},
                {value:"63", label: "Hà Nam"},
                {value:"67", label: "Nam Định"},
                {value:"18", label: "Ninh Bình"},
                {value:"21", label: "Thanh Hóa"},
                {value:"22", label: "Nghệ An"},
                {value:"23", label: "Hà Tĩnh"},
                {value:"24", label: "Quảng Bình"},
                {value:"25", label: "Quảng Trị"},
                {value:"26", label: "Thừa Thiên–Huế"},
                {value:"DN", label: "Đà Nẵng"},
                {value:"27", label: "Quảng Nam"},
                {value:"29", label: "Quảng Ngãi"},
                {value:"31", label: "Bình Định"},
                {value:"32", label: "Phú Yên"},
                {value:"34", label: "Khánh Hòa"},
                {value:"36", label: "Ninh Thuận"},
                {value:"40", label: "Bình Thuận"},
                {value:"28", label: "Kon Tum"},
                {value:"30", label: "Gia Lai"},
                {value:"33", label: "Đắk Lắk"},
                {value:"72", label: "Đắk Nông"},
                {value:"35", label: "Lâm Đồng"},
                {value:"58", label: "Bình Phước"},
                {value:"37", label: "Tây Ninh"},
                {value:"57", label: "Bình Dương"},
                {value:"39", label: "Đồng Nai"},
                {value:"43", label: "Bà Rịa–Vũng Tàu"},
                {value:"41", label: "Long An"},
                {value:"46", label: "Tiền Giang"},
                {value:"50", label: "Bến Tre"},
                {value:"51", label: "Trà Vinh"},
                {value:"49", label: "Vĩnh Long"},
                {value:"45", label: "Đồng Tháp"},
                {value:"44", label: "An Giang"},
                {value:"47", label: "Kiên Giang"},
                {value:"CT", label: "Cần Thơ"},
                {value:"73", label: "Hậu Giang"},
                {value:"52", label: "Sóc Trăng"},
                {value:"55", label: "Bạc Liêu"},
                {value:"59", label: "Cà Mau"},
            ]
        },
        {
            country: 'CR',
            states: 
            [
                {},
                {value: 'SJ', label: "San José"},
                {value: 'A', label: "Alajuela"},
                {value: 'C', label: "Cartago"},
                {value: 'H', label: 'Heredia'},
                {value: 'G', label: 'Guanacaste'},
                {value: 'P', label: 'Puntarenas'},
                {value: 'L', label: 'Limón'}
            ]
        },
        {
            country: 'NZ',
            states: 
            [
                {},
                {value: 'AUK', label: "Auckland"},
                {value: 'NPL', label: "New Plymouth"},
                {value: 'HKB', label: "Hawke's Bay"},
                {value: 'WGN', label: 'Wellington'},
                {value: 'NSN', label: 'Nelson'},
                {value: 'MBH', label: 'Marlborough'},
                {value: 'CAN', label: 'Canterbury'},
                {value: 'OTA', label: 'Otago'},
            ]
        },
        
   
]
    